import CircleProgress from "./LanguagePerc";
import shared from "../../pages/00_resumes/SharedCSS.module.css";

function LanguageCard({ language, level, percentage }) {
  return (
    <div className={shared.language}>
      <CircleProgress percentage={percentage} />
      <div className={shared.info}>
        <h1>{language}</h1>
        <h2>{level}</h2>
      </div>
    </div>
  );
}

export default LanguageCard;
